import React from 'react'

export default function skills() {
    return (
        <>
             <section className="resume-section" id="skills">
                <div className="resume-section-content">
                    <h2 className="mb-5">Skills</h2>
                    <div className="subheading mb-3">Programming Languages & Tools</div>
                    <ul className="list-inline dev-icons">
                    <li className="list-inline-item"  title="c#"><i className="fab fa-windows"></i></li>
                    <li className="list-inline-item" title="Sql Server"><i className="fa fa-database"></i></li>
                        <li className="list-inline-item" title="html5"><i className="fab fa-html5"></i></li>
                        <li className="list-inline-item"  title="css3"><i className="fab fa-css3-alt"></i></li> 
                        <li className="list-inline-item" title="React js"><i className="fab fa-react"></i></li> 
                        <li className="list-inline-item" title="Github"><i className="fab fa-github"></i></li>
                        <li className="list-inline-item" title="npm"><i className="fab fa-npm"></i></li>
                    </ul>
                    <div className="subheading mb-3">Workflow</div>
                    <ul className="fa-ul mb-0">
                        <li>
                            <span className="fa-li"><i className="fas fa-check"></i></span>Mobile-First, Responsive Design
                        </li>
                        <li>
                            <span className="fa-li"><i className="fas fa-check"></i></span>Cross Browser Testing & Debugging
                        </li>
                        <li>
                            <span className="fa-li"><i className="fas fa-check"></i></span>Cross Functional Teams
                        </li>
                        <li>
                            <span className="fa-li"><i className="fas fa-check"></i></span>In-depth knowledge of developing and supporting ASP/ASP.NET, C# .NET JavaScript and AJAX applications
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Extensive knowledge of enterprise environment analyzing, designing and developing applications for Web & Windows 
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Thorough knowledge of developing a data intensive web site with a SQL data layer
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Skilled in Object-Oriented programming
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Proficient with XML and using schemas
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Ability to work capably under stress and to juggle multiple tasks within tight deadlines
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Strong ability to research & solve complex issues independently
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Proven ability to manage a source code library
                        </li>
                        <li><span className="fa-li"><i className="fas fa-check"></i></span>
                        Excellent communication and technical documentation skills
                        </li>
                    </ul>
                </div>
            </section>
            <hr className="m-0" />
        </>
    )
}
